/// <amd-module name="Feed/Legacy/Protocols/Ivy/IvyDevelopment" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import * as Tooltip from "VSSUI/Tooltip";

import * as PackageResources from "Feed/Common/Resources";
import { ExternalLink } from "Feed/Legacy/Components/ExternalLink";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";
import { isSafeProtocol } from "Feed/Legacy/Helpers/UrlHelper";
import { PackageAttribute } from "Feed/Legacy/Protocols/Components/PackageAttribute";
import { IProjectAttribute } from "Feed/Legacy/Protocols/Components/PackageDevelopment";
import { IvyCiConstants } from "Feed/Legacy/Protocols/Ivy/Constants/IvyConstants";
import * as IvyFileHelper from "Feed/Legacy/Protocols/Ivy/IvyFileHelper";
import { htmlEncode } from "Feed/Legacy/Utils/Html";

export interface IIvyDevelopmentProps {
    pageContext: IVssPageContext;
    feedId: string;
    normalizedName: string;
    normalizedVersion: string;
    projectConfigurations: IProjectAttribute[];
    projectAttributes: IProjectAttribute[];
}

export class IvyDevelopment extends React.PureComponent<IIvyDevelopmentProps> {
    public render(): JSX.Element {
        if (!this.showDevelopment()) {
            return null;
        }
        return (
            <div className="ivy-development">
                <PackageAttribute title={PackageResources.IvyAttributes_DevelopmentTitle}>
                    {this.props.projectAttributes && this.props.projectAttributes.length > 0 && (
                        <div>
                            <div className="package-group-header" role="heading" aria-level={3}>
                                {PackageResources.IvyDevelopment_ProjectHeading}
                            </div>
                            {this.props.projectAttributes.map((attribute: IProjectAttribute, index: number) => {
                                return (
                                    <div className="package-attribute-item" key={index}>
                                        <Tooltip.TooltipHost content={attribute.text}>
                                            <span className={"package-attribute-item-icon " + attribute.iconClass} />
                                            {isSafeProtocol(attribute.url || "") ? (
                                                <ExternalLink
                                                    pageContext={this.props.pageContext}
                                                    href={htmlEncode(attribute.url)}
                                                    ciContext={IvyCiConstants.IvyDevelopment}
                                                    onClick={() =>
                                                        CustomerIntelligenceHelper.publishEvent(
                                                            this.props.pageContext,
                                                            attribute.onClickCiFeature
                                                        )
                                                    }
                                                >
                                                    {attribute.text}
                                                    <span className="bowtie-icon bowtie-navigate-external" />
                                                </ExternalLink>
                                            ) : attribute.onClickCiFeature ===
                                              IvyCiConstants.ModuleIndexAnchorClicked ? (
                                                <ExternalLink
                                                    pageContext={this.props.pageContext}
                                                    href="#"
                                                    rel="noopener noreferrer"
                                                    ciContext={IvyCiConstants.IvyDevelopment}
                                                    onClick={ev => {
                                                        ev.preventDefault();
                                                        IvyFileHelper.getHrefLink(
                                                            this.props.pageContext,
                                                            "index",
                                                            this.props.feedId,
                                                            this.props.normalizedName,
                                                            this.props.normalizedVersion,
                                                            (href: string) => {
                                                                const newWindow = window.open(href, "_blank");
                                                                if (newWindow) {
                                                                    newWindow.opener = undefined;
                                                                }
                                                            }
                                                        );
                                                        CustomerIntelligenceHelper.publishEvent(
                                                            this.props.pageContext,
                                                            attribute.onClickCiFeature
                                                        );
                                                    }}
                                                >
                                                    {attribute.text}
                                                    <span className="bowtie-icon bowtie-navigate-external" />
                                                </ExternalLink>
                                            ) : (
                                                <label className="project-attibute-text">{attribute.text}</label>
                                            )}
                                        </Tooltip.TooltipHost>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {this.props.projectConfigurations && this.props.projectConfigurations.length > 0 && (
                        <div>
                            <div className="package-group-spacer" />
                            <div className="package-group-header" role="heading" aria-level={3}>
                                {PackageResources.IvyDevelopment_ConfigurationsHeading}
                            </div>
                            {this.props.projectConfigurations.map((config: IProjectAttribute) => {
                                return (
                                    <div className="package-attribute-item" key={config.text}>
                                        <Tooltip.TooltipHost content={config.text}>
                                            <label className="project-attibute-text">{config.text}</label>
                                        </Tooltip.TooltipHost>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </PackageAttribute>
            </div>
        );
    }

    private showDevelopment(): boolean {
        return (
            (this.props.projectAttributes && this.props.projectAttributes.length > 0) ||
            (this.props.projectConfigurations && this.props.projectConfigurations.length > 0)
        );
    }
}
